// client/src/utils/sanitizeHtml.js
// Sanitisation HTML — utilise DOMPurify (standard du marché) avec repli regex.
// Usage : aperçu d'email marketing côté admin (contenu saisi par l'admin).
//
// v1.170 : chargement de DOMPurify RÉSILIENT (require protégé au lieu d'un
// import statique). Si le module est introuvable (bundle périmé en cache,
// node_modules incomplet, etc.), on n'écroule PLUS toute l'app en plein
// écran : on bascule simplement sur le repli regex. Dès que DOMPurify est
// dispo, il est utilisé normalement.
// Maxula

// Chargement protégé : un module manquant ne doit jamais throw à l'init.
let DOMPurify = null;
try {
  // eslint-disable-next-line global-require
  const mod = require('dompurify');
  DOMPurify = (mod && mod.default) ? mod.default : mod;
} catch (e) {
  DOMPurify = null;
}

function regexFallback(s) {
  return String(s)
    .replace(/<\s*(script|style|iframe|object|embed|link|meta)\b[^>]*>[\s\S]*?<\s*\/\s*\1\s*>/gi, '')
    .replace(/<\s*(script|style|iframe|object|embed|link|meta)\b[^>]*\/?>/gi, '')
    .replace(/\son\w+\s*=\s*"[^"]*"/gi, '')
    .replace(/\son\w+\s*=\s*'[^']*'/gi, '')
    .replace(/\son\w+\s*=\s*[^\s>]+/gi, '')
    .replace(/(href|src)\s*=\s*("|')\s*javascript:[^"']*\2/gi, '$1=$2#$2')
    .replace(/(href|src)\s*=\s*javascript:[^\s>]+/gi, '$1="#"');
}

export default function sanitizeHtml(dirty = '') {
  const s = String(dirty == null ? '' : dirty);
  try {
    if (DOMPurify && typeof DOMPurify.sanitize === 'function') {
      return DOMPurify.sanitize(s, { USE_PROFILES: { html: true } });
    }
  } catch (e) { /* repli ci-dessous */ }
  return regexFallback(s);
}
